import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_additional",
  "use": "dashboard_card_icon_menu_additional-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dashboard_card_icon_menu_additional\"><rect width=\"20\" height=\"20\" rx=\"5\" fill=\"#2C2D2E\" /><rect x=\"9.074\" y=\"4.444\" width=\"1.852\" height=\"11.111\" rx=\".556\" fill=\"#fff\" /><rect x=\"15.557\" y=\"9.074\" width=\"1.852\" height=\"11.111\" rx=\".556\" transform=\"rotate(90 15.557 9.074)\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol